export default "__VITE_ASSET__DN0jdr0V__"